import { useMemo, useEffect } from 'react'
import { useStaticData } from '../../../data'
import { getRegionFromLocationId } from '../../app/selectors'
import { useLoadSedaData } from '../../loader'

/**
 * Hook that returns locations data given an array of location IDs
 */
export default function useLocationIdsData(locations) {
  const loadSedaData = useLoadSedaData()
  const data = useStaticData(state => state.data)

  const uniqueRegions = useMemo(() => {
    const regions = locations.map(locationId =>
      getRegionFromLocationId(locationId)
    )
    return [...new Set(regions)]
  }, [locations])

  // trigger loads for region data in case they haven't been loaded
  useEffect(() => {
    uniqueRegions.forEach(r => loadSedaData(r))
  }, [uniqueRegions, loadSedaData])

  return useMemo(() => {
    return (
      locations
        .map(id => {
          const region = getRegionFromLocationId(id)
          if(!region) return null
          const regionData = data[region]
          return regionData
            ? regionData.find(d => d.id === id)
            : null
        })
        // filter out locations with no data, or locations that already exist
        .filter(
          l => !!l && !locations.find(loc => loc.id === l.id)
        )
    )
  }, [locations, data])
}
